<cm-register-as
    [roleFromInput]="SIGN_UP_TYPES.PROFESSIONAL"
    [token]="token"
    [organizationRoles]="organizationRoles"
    class="register"
    [isSelfEnrollment]="true"
    [title]="title"
    (callback)="handleRegisterAsResponse($event)"
>
</cm-register-as>
